module.exports = __webpack_public_path__ + "img/chrome_os.f513ab66.svg";